import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.korslovo.review');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { RU, normalizeYo } from "src/libs/portal/korslovo/i18n";
import { TTS } from "src/libs/portal/korslovo/tts";

@Component({
    selector: 'wiz-page-korslovo-review',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.korslovo.review/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.card-scene {
  perspective: 1000px;
}

.card-body {
  position: relative;
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  transform-style: preserve-3d;
}
.card-body.is-flipped {
  transform: rotateY(180deg);
}

.card-face {
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.card-front {
  min-height: 240px;
}

.card-back {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  min-height: 240px;
  transform: rotateY(180deg);
}

@keyframes bounceIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  60% {
    transform: scale(1.15);
  }
  80% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.animate-bounce-in {
  animation: bounceIn 0.6s ease-out;
}

/* XP Badge */
.xp-earned-badge {
  animation: xpBadgeIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
}

@keyframes xpBadgeIn {
  0% {
    transform: scale(0) rotate(-20deg);
    opacity: 0;
  }
  60% {
    transform: scale(1.15) rotate(5deg);
    opacity: 1;
  }
  100% {
    transform: scale(1) rotate(0deg);
    opacity: 1;
  }
}
/* Level Up Modal */
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes cardSlideUp {
  0% {
    transform: translateY(40px) scale(0.9);
    opacity: 0;
  }
  100% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}
@keyframes levelUpStar {
  0%, 100% {
    transform: scale(1) rotate(0deg);
  }
  25% {
    transform: scale(1.15) rotate(-10deg);
  }
  50% {
    transform: scale(1.25) rotate(0deg);
  }
  75% {
    transform: scale(1.15) rotate(10deg);
  }
}`],
})
export class PageKorslovoReviewComponent implements OnInit, OnDestroy {
    public ru = RU;
    public loading: boolean = true;
    public words: any[] = [];
    public totalDue: number = 0;
    public upcomingCount: number = 0;
    public masteredCount: number = 0;
    public mode: string = 'list'; // list, card, quiz
    public currentIndex: number = 0;
    public flipped: boolean = false;
    public quizAnswer: any = null;
    public quizAnswered: boolean = false;
    public quizCorrect: boolean = false;

    // Batch tracking for XP
    public batchPromotes: number = 0;
    public batchMastered: number = 0;
    public wordsReviewed: number = 0;

    // XP animation state
    public xpResult: any = null;
    public showXpAnimation: boolean = false;
    public showLevelUp: boolean = false;
    public xpAnimValue: number = 0;
    public batchComplete: boolean = false;

    // Swipe gesture
    private touchStartX: number = 0;
    private touchStartY: number = 0;
    private isSwiping: boolean = false;

    private tts: TTS = new TTS();

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadWords();
    }

    ngOnDestroy() {
        this.tts.stop();
    }

    public async loadWords() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("list");
        if (code === 200) {
            this.words = data.due || [];
            this.totalDue = data.total_due || 0;
            this.upcomingCount = data.upcoming_count || 0;
            this.masteredCount = data.mastered_count || 0;
        }

        this.loading = false;
        await this.service.render();
    }

    public get remainingAfterBatch(): number {
        return Math.max(0, this.totalDue - this.words.length);
    }

    public async startReview() {
        if (this.words.length === 0) return;
        this.mode = 'card';
        this.currentIndex = 0;
        this.flipped = false;
        this.batchPromotes = 0;
        this.batchMastered = 0;
        this.wordsReviewed = 0;
        this.xpResult = null;
        this.showXpAnimation = false;
        this.showLevelUp = false;
        this.xpAnimValue = 0;
        this.batchComplete = false;
        await this.service.render();
    }

    public get currentWord(): any {
        return this.words[this.currentIndex] || {};
    }

    public shouldShowHint(word: any): boolean {
        if (!word || !word.description_ru || !word.russian) return false;
        const desc = normalizeYo(word.description_ru.toLowerCase());
        const russian = normalizeYo(word.russian.toLowerCase());
        const variants = russian.split(/\s*[/,]\s*/);
        for (const v of variants) {
            if (v.trim() && desc.includes(v.trim())) return false;
        }
        const parenMatch = word.russian.match(/\(([^)]+)\)/);
        if (parenMatch) {
            const inner = normalizeYo(parenMatch[1].trim().toLowerCase());
            if (inner && desc.includes(inner)) return false;
        }
        return true;
    }

    public get progressPercent(): number {
        if (this.words.length === 0) return 0;
        return Math.round(((this.currentIndex + 1) / this.words.length) * 100);
    }

    public reviewLevelLabel(level: number): string {
        const labels = ['1д', '3д', '7д', '14д', '30д'];
        if (level >= 0 && level < labels.length) return labels[level];
        return '✓';
    }

    public async flip() {
        if (this.isSwiping) return;
        this.flipped = !this.flipped;
        await this.service.render();
    }

    public onTouchStart(e: TouchEvent) {
        this.touchStartX = e.touches[0].clientX;
        this.touchStartY = e.touches[0].clientY;
        this.isSwiping = false;
    }

    public async onTouchEnd(e: TouchEvent) {
        const dx = e.changedTouches[0].clientX - this.touchStartX;
        const dy = e.changedTouches[0].clientY - this.touchStartY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 60) {
            this.isSwiping = true;
            if (dx < 0) {
                this.flipped = false;
                await this.nextCard();
            }
        }
    }

    public speak(text?: string) {
        this.tts.speak(text || this.currentWord.korean);
    }

    public async nextCard() {
        this.flipped = false;
        if (this.currentIndex < this.words.length - 1) {
            this.currentIndex++;
        } else {
            this.mode = 'quiz';
            this.currentIndex = 0;
            this.shuffleQuiz();
        }
        await this.service.render();
    }

    // Mini quiz
    public quizChoices: any[] = [];

    private shuffleQuiz() {
        const correct = this.currentWord;
        const pool = this.words.filter(w => w.word_id !== correct.word_id);
        const wrongCount = Math.min(3, pool.length);
        const wrong = this.shuffleArray(pool).slice(0, wrongCount);

        this.quizChoices = [
            { text: correct.korean, word_id: correct.word_id, correct: true },
            ...wrong.map(w => ({ text: w.korean, word_id: w.word_id, correct: false }))
        ];
        this.quizChoices = this.shuffleArray(this.quizChoices);
        this.quizAnswer = null;
        this.quizAnswered = false;
        this.quizCorrect = false;
    }

    public async selectQuizAnswer(choice: any) {
        if (this.quizAnswered) return;
        this.quizAnswer = choice;
        this.quizAnswered = true;
        this.quizCorrect = choice.correct;
        this.wordsReviewed++;

        if (choice.correct) {
            const { code, data } = await wiz.call("promote", { word_id: this.currentWord.word_id });
            if (code === 200 && data) {
                if (data.promoted) this.batchPromotes++;
                if (data.mastered) this.batchMastered++;
            }
        } else {
            await wiz.call("demote", { word_id: this.currentWord.word_id });
        }

        await this.service.render();
    }

    public async nextQuiz() {
        if (this.currentIndex < this.words.length - 1) {
            this.currentIndex++;
            this.shuffleQuiz();
        } else {
            // 배치 완료 — XP 지급
            this.batchComplete = true;
            const { code, data } = await wiz.call("finish_batch", {
                words_reviewed: this.wordsReviewed,
                promotes: this.batchPromotes,
                mastered: this.batchMastered
            });
            if (code === 200 && data) {
                this.xpResult = data;
                await this.service.render();
                await this.animateXp(data);
                return;
            }
            // Fallback: reload
            this.mode = 'list';
            await this.loadWords();
        }
        await this.service.render();
    }

    public async finishBatchAndContinue() {
        this.batchComplete = false;
        this.mode = 'list';
        await this.loadWords();
    }

    public goBack() {
        this.service.href('/dashboard');
    }

    private async animateXp(xp: any) {
        this.showXpAnimation = true;
        this.xpAnimValue = 0;
        await this.service.render();

        const target = xp.xp_earned || 0;
        const steps = 20;
        const delay = Math.max(30, 600 / steps);
        for (let i = 1; i <= steps; i++) {
            this.xpAnimValue = Math.round((target / steps) * i);
            await this.service.render();
            await new Promise(r => setTimeout(r, delay));
        }
        this.xpAnimValue = target;
        await this.service.render();

        if (xp.level_up) {
            await new Promise(r => setTimeout(r, 400));
            this.showLevelUp = true;
            await this.service.render();
        }
    }

    public async dismissLevelUp() {
        this.showLevelUp = false;
        await this.service.render();
    }

    private shuffleArray(arr: any[]): any[] {
        const a = [...arr];
        for (let i = a.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [a[i], a[j]] = [a[j], a[i]];
        }
        return a;
    }
}

export default PageKorslovoReviewComponent;